/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetChatPermissionsViewDto { 
    /**
     * Пользователь является администратором данного чата
     */
    isChatAdmin?: boolean;
    /**
     * Пользователь может удалить данный чат
     */
    canDeleteChat?: boolean;
    /**
     * Пользователь может поменять название данного чата
     */
    canEditChat?: boolean;
    /**
     * Пользователь может менять состав участников чата (добавлять, исключать)
     */
    canManageUsers?: boolean;
    /**
     * Пользователь может менять состав админов чата (добавлять, исключать)
     */
    canManageAdmins?: boolean;
    /**
     * Пользователь может отправлять сообщения (эмодзи) в чат
     */
    canSendMessages?: boolean;
    /**
     * Пользователь может отправлять файлы в чат
     */
    canSendFiles?: boolean;
    /**
     * Пользователь может отправлять реакции на контент
     */
    canSendReactions?: boolean;
    /**
     * Пользователь может удалять сообщения в чате
     */
    canDeleteMessages?: boolean;
    /**
     * Пользователь может покидать чат
     */
    canLeaveChat?: boolean;
}

